import axios from "axios";
import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Back from "../components/button/back";

const KURKUMlist = () => {
  const { id } = useParams();

  /* ================= STATE ================= */
  const [TPData, setTPData] = useState([]);
  const [loading, setLoading] = useState(false);

  const [filterKelas, setFilterKelas] = useState("");
  const [filterSemester, setFilterSemester] = useState("");
  const [filterMapel, setFilterMapel] = useState("");
  const [filterRombel, setFilterRombel] = useState("");

  // STATE EDIT PROSES
  const [editData, setEditData] = useState({});

  /* ================= FETCH ================= */
  useEffect(() => {
    fetchTP();
  }, []);

  const fetchTP = async () => {
    try {
      const token = localStorage.getItem("token");
      const res = await axios.get(`${process.env.REACT_APP_API_URL}api/tp`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setTPData(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  /* ================= FILTER ================= */
  const filteredTP = TPData.filter((d) => {
    if (filterKelas && d.kelas !== filterKelas) return false;
    if (filterSemester && d.semester !== filterSemester) return false;
    if (filterMapel && d.mapel !== filterMapel) return false;
    if (filterRombel && d.rombel !== filterRombel) return false;
    return true;
  });

  const allEmpty =
    !filterKelas && !filterSemester && !filterMapel && !filterRombel;

  /* ================= TAMBAH PROSES ================= */
  const tambahProses = (tpId, isiTpId) => {
    const tempId = `temp-${Date.now()}`;

    setEditData((prev) => ({
      ...prev,
      [tempId]: {
        tpId,
        isiTpId,
        subTP: "",
        materi: "",
        tanggal: "",
        kecapaian: "Belum Selesai",
        permasalahan: "",
        isNew: true, // 🔑 PENANDA PENTING
      },
    }));
  };

  const truncateText = (text, maxWords) => {
    const words = text.split(" ");
    if (words.length > maxWords) {
      return words.slice(0, maxWords).join(" ") + " ...";
    }
    return text;
  };

  const filteredTPData = TPData.filter((item) => {
    if (filterKelas && item.kelas !== filterKelas) return false;
    if (filterSemester && item.semester !== filterSemester) return false;
    if (filterMapel && item.mapel !== filterMapel) return false;
    if (filterRombel && item.rombel !== filterRombel) return false; // filter rombel
    return true;
  });

  const isAllFiltersEmpty =
    filterKelas.trim() === "" &&
    filterSemester.trim() === "" &&
    filterMapel.trim() === "" &&
    filterRombel.trim() === "";

  /* ================= HAPUS PROSES ================= */
  const hapusProses = async (tpId, isiTpId, prosesId) => {
    try {
      const token = localStorage.getItem("token");

      await axios.delete(
        `${process.env.REACT_APP_API_URL}api/tp/${tpId}/isi/${isiTpId}/proses/${prosesId}`,
        { headers: { Authorization: `Bearer ${token}` } },
      );

      fetchTP();
    } catch (err) {
      console.error(err);
    }
  };

  /* ================= SIMPAN SEMUA ================= */
  const simpanSemua = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem("token");

      for (const prosesKey in editData) {
        const { tpId, isiTpId, isNew, ...data } = editData[prosesKey];

        // ✅ PAYLOAD AMAN (HANYA YANG DIISI)
        const payload = {};

        if (data.subTP !== undefined)
          payload.subTP = data.subTP.split(",").map((s) => s.trim());

        if (data.materi !== undefined)
          payload.materi = data.materi.split(",").map((m) => m.trim());

        if (data.tanggal !== undefined) payload.tanggal = data.tanggal;

        if (data.kecapaian !== undefined) payload.kecapaian = data.kecapaian;

        if (data.permasalahan !== undefined)
          payload.permasalahan = data.permasalahan;

        /* ================= CREATE ================= */
        if (isNew) {
          await axios.post(
            `${process.env.REACT_APP_API_URL}api/tp/${tpId}/isi/${isiTpId}/proses`,
            payload,
            { headers: { Authorization: `Bearer ${token}` } },
          );
        } else {
          /* ================= UPDATE ================= */
          await axios.post(
            `${process.env.REACT_APP_API_URL}api/tp/${tpId}/isi/${isiTpId}/proses/${prosesKey}`,
            payload,
            { headers: { Authorization: `Bearer ${token}` } },
          );
        }
      }

      alert("Perubahan berhasil disimpan");
      setEditData({});
      fetchTP();
    } catch (err) {
      console.error(err);
      alert("Gagal menyimpan perubahan");
    } finally {
      setLoading(false);
    }
  };

  /* ================= JSX ================= */
  return (
    <div className="max-w-7xl mx-auto bg-white p-5 rounded-lg shadow">
      <h2 className="text-2xl font-bold text-center mb-6">Daftar TP</h2>

      <Link to="/addTP">
        <button className="bg-blue-500 text-white px-4 py-2 rounded mb-4">
          Tambah TP
        </button>
      </Link>

      {/* FILTER */}
      <div className="grid gap-4 bg-white p-5 rounded-lg border border-slate-300 shadow-md">
        {/* Pilihan Kelas */}
        <div className="flex items-center">
          <label className="w-1/4 font-medium">Kelas:</label>
          <select
            value={filterKelas}
            onChange={(e) => setFilterKelas(e.target.value)}
            className="flex-1 border border-slate-500 rounded-lg px-4 py-2"
          >
            <option value="">Semua Kelas</option>
            {[1, 2, 3, 4, 5, 6].map((kelas) => (
              <option key={kelas} value={kelas}>
                {kelas}
              </option>
            ))}
          </select>
        </div>

        {/* Pilihan Semester */}
        <div className="flex items-center">
          <label className="w-1/4 font-medium">Semester:</label>
          <select
            value={filterSemester}
            onChange={(e) => setFilterSemester(e.target.value)}
            className="flex-1 border border-slate-500 rounded-lg px-4 py-2"
          >
            <option value="">Semua Semester</option>
            {[1, 2].map((semester) => (
              <option key={semester} value={semester}>
                {semester}
              </option>
            ))}
          </select>
        </div>

        {/* Pilihan Mata Pelajaran */}
        <div className="flex items-center">
          <label className="w-1/4 font-medium">Mata Pelajaran:</label>
          <select
            value={filterMapel}
            onChange={(e) => setFilterMapel(e.target.value)}
            className="flex-1 border border-slate-500 rounded-lg px-4 py-2"
          >
            <option value="">Semua Mata Pelajaran</option>
            {[
              "MTK",
              "BIndo",
              "BIng",
              "IPAS",
              "PKN",
              "PJOK",
              "MULOK",
              "SENIBUDAYA",
              "PAI",
              "Koding",
            ].map((mapel) => (
              <option key={mapel} value={mapel}>
                {mapel}
              </option>
            ))}
          </select>
        </div>

        {/* Pilihan Rombel */}
        <div className="flex items-center">
          <label className="w-1/4 font-medium">Rombel:</label>
          <select
            value={filterRombel}
            onChange={(e) => setFilterRombel(e.target.value)}
            className="flex-1 border border-slate-500 rounded-lg px-4 py-2"
          >
            <option value="">Semua Rombel</option>
            {["A", "B", "C", "D"].map((r) => (
              <option key={r} value={r}>
                {r}
              </option>
            ))}
          </select>
        </div>
      </div>

      {isAllFiltersEmpty && <p>Tidak ada data yang dipilih.</p>}
      {!isAllFiltersEmpty && filteredTPData.length === 0 && (
        <p>Tidak ada data yang sesuai dengan filter yang dipilih.</p>
      )}
      <div className="overflow-x-auto">
        {!isAllFiltersEmpty && filteredTPData.length > 0 && (
          <table className="min-w-full bg-white mt-5 border border-slate-300">
            <thead>
              <tr>
                <th className="py-2 border">TP</th>
                <th className="py-2 border">Deskripsi</th>
                <th className="py-2 border">Rombel</th>
                <th className="py-2 border">Aksi</th>
              </tr>
            </thead>
            <tbody>
              {filteredTPData.map((item) => (
                <tr key={item._id}>
                  <td className="border px-4 py-2">
                    <ul>
                      {item.TP.map((tp, index) => (
                        <li key={index}>TP {index + 1}:</li>
                      ))}
                    </ul>
                  </td>
                  <td className="border px-4 py-2">
                    {item.TP.map((tp, index) => (
                      <p key={index}>{truncateText(tp.isiTP, 8)}</p>
                    ))}
                  </td>
                  <td className="border px-4 py-2 text-center">
                    {item.rombel}
                  </td>
                  <td className="border px-4 py-2">
                    <div className="flex justify-center">
                      <Link
                        to={`/editTP/${item._id}`}
                        state={{ from: `/cpadmin/${id}` }}
                      >
                        <button className="bg-green-500 text-white px-4 py-2 rounded">
                          Edit
                        </button>
                      </Link>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      <div className="flex justify-center mt-10 mb-4 font-bold text-2xl">
        <h1>Update TP</h1>
      </div>

      {allEmpty && (
        <p className="text-center text-gray-500">
          Pilih filter terlebih dahulu
        </p>
      )}

      {!allEmpty &&
        filteredTP.map((item) => (
          <div
            key={item._id}
            className="border rounded-xl p-4 mb-6 shadow-sm bg-white"
          >
            {/* HEADER */}
            <div className="mb-4">
              <h3 className="font-bold text-sm md:text-base text-gray-700">
                {item.mapel} | Kelas {item.kelas} | Rombel {item.rombel}
              </h3>
            </div>

            {item.TP.map((tp, i) => (
              <div key={tp._id} className="mb-8">
                {/* CP HEADER */}
                <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-2 mb-3">
                  <p className="font-semibold text-sm md:text-base">
                    TP {i + 1}: <span className="font-normal">{tp.isiTP}</span>
                  </p>

                  <button
                    onClick={() => tambahProses(item._id, tp._id)}
                    className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-md text-sm w-full md:w-auto"
                  >
                    + Tambah Proses
                  </button>
                </div>

                {/* TABLE */}
                <div className="overflow-x-auto rounded-lg border">
                  <table className="min-w-[900px] w-full text-xs md:text-sm">
                    <thead className="bg-gray-100">
                      <tr className="text-left">
                        <th className="p-2">Sub TP</th>
                        <th className="p-2">Materi</th>
                        <th className="p-2">Tanggal</th>
                        <th className="p-2">Kecapaian</th>
                        <th className="p-2">Permasalahan</th>
                        <th className="p-2 text-center">Aksi</th>
                      </tr>
                    </thead>

                    <tbody>
                      {tp.prosesTP.map((p) => (
                        <tr key={p._id} className="border-t hover:bg-gray-50">
                          {/* SUB TP & MATERI */}
                          {["subTP", "materi"].map((f) => (
                            <td key={f} className="p-2">
                              <input
                                className="border rounded px-2 py-1 w-full text-xs md:text-sm"
                                value={
                                  editData[p._id]?.[f] ??
                                  (Array.isArray(p[f]) ? p[f].join(",") : "")
                                }
                                maxLength={f === "subTP" ? 200 : 250}
                                onChange={(e) =>
                                  setEditData({
                                    ...editData,
                                    [p._id]: {
                                      ...(editData[p._id] || {}),
                                      tpId: item._id,
                                      isiTpId: tp._id,
                                      [f]: e.target.value,
                                    },
                                  })
                                }
                              />
                              {/* Optional: info jumlah karakter */}
                              <div className="text-[10px] text-gray-500 text-right">
                                {(editData[p._id]?.[f] ?? "").length}/
                                {f === "subTP" ? 200 : 250}
                              </div>
                            </td>
                          ))}

                          {/* TANGGAL */}
                          <td className="p-2">
                            <input
                              type="date"
                              className="border rounded px-2 py-1 w-full"
                              value={
                                editData[p._id]?.tanggal ??
                                (p.tanggal || "").slice(0, 10)
                              }
                              onChange={(e) =>
                                setEditData({
                                  ...editData,
                                  [p._id]: {
                                    ...(editData[p._id] || {}),
                                    tpId: item._id,
                                    isiTpId: tp._id,
                                    tanggal: e.target.value,
                                  },
                                })
                              }
                            />
                          </td>

                          {/* KECAPAIAN */}
                          <td className="p-2">
                            <select
                              className="border rounded px-2 py-1 w-full"
                              value={editData[p._id]?.kecapaian ?? p.kecapaian}
                              onChange={(e) =>
                                setEditData({
                                  ...editData,
                                  [p._id]: {
                                    ...(editData[p._id] || {}),
                                    tpId: item._id,
                                    isiTpId: tp._id,
                                    kecapaian: e.target.value,
                                  },
                                })
                              }
                            >
                              <option>Belum Selesai</option>
                              <option>Selesai</option>
                            </select>
                          </td>

                          {/* PERMASALAHAN */}
                          <td className="p-2">
                            <textarea
                              rows="2"
                              className="border rounded px-2 py-1 w-full resize-none"
                              maxLength={300}
                              value={
                                editData[p._id]?.permasalahan ?? p.permasalahan
                              }
                              onChange={(e) =>
                                setEditData({
                                  ...editData,
                                  [p._id]: {
                                    ...(editData[p._id] || {}),
                                    tpId: item._id,
                                    isiTpId: tp._id,
                                    permasalahan: e.target.value,
                                  },
                                })
                              }
                            />
                          </td>

                          {/* AKSI */}
                          <td className="p-2 text-center">
                            <button
                              onClick={() =>
                                hapusProses(item._id, tp._id, p._id)
                              }
                              className="bg-red-500 hover:bg-red-600 text-white px-3 py-1 rounded text-xs"
                            >
                              Hapus
                            </button>
                          </td>
                        </tr>
                      ))}
                      {Object.entries(editData)
                        .filter(([, v]) => v.isNew && v.isiTpId === tp._id)
                        .map(([tempId, v]) => (
                          <tr key={tempId} className="border-t bg-yellow-50">
                            {["subTP", "materi"].map((f) => {
                              const maxLength = f === "subTP" ? 200 : 250;

                              return (
                                <td key={f} className="p-2">
                                  <input
                                    className="border rounded px-2 py-1 w-full text-xs md:text-sm"
                                    value={v[f] || ""}
                                    maxLength={maxLength}
                                    onChange={(e) =>
                                      setEditData({
                                        ...editData,
                                        [tempId]: {
                                          ...v,
                                          [f]: e.target.value,
                                        },
                                      })
                                    }
                                  />

                                  {/* Optional: counter karakter */}
                                  <div className="text-[10px] text-gray-500 text-right">
                                    {(v[f] || "").length}/{maxLength}
                                  </div>
                                </td>
                              );
                            })}

                            <td className="p-2">
                              <input
                                type="date"
                                className="border rounded px-2 py-1 w-full"
                                value={v.tanggal}
                                onChange={(e) =>
                                  setEditData({
                                    ...editData,
                                    [tempId]: {
                                      ...v,
                                      tanggal: e.target.value,
                                    },
                                  })
                                }
                              />
                            </td>

                            <td className="p-2">
                              <select
                                className="border rounded px-2 py-1 w-full"
                                value={v.kecapaian}
                                onChange={(e) =>
                                  setEditData({
                                    ...editData,
                                    [tempId]: {
                                      ...v,
                                      kecapaian: e.target.value,
                                    },
                                  })
                                }
                              >
                                <option>Belum Selesai</option>
                                <option>Selesai</option>
                              </select>
                            </td>

                            <td className="p-2">
                              <textarea
                                rows="2"
                                className="border rounded px-2 py-1 w-full"
                                maxLength={300}
                                value={v.permasalahan}
                                onChange={(e) =>
                                  setEditData({
                                    ...editData,
                                    [tempId]: {
                                      ...v,
                                      permasalahan: e.target.value,
                                    },
                                  })
                                }
                              />
                            </td>

                            <td className="p-2 text-center">
                              <button
                                onClick={() => {
                                  const copy = { ...editData };
                                  delete copy[tempId];
                                  setEditData(copy);
                                }}
                                className="bg-gray-400 text-white px-3 py-1 rounded text-xs"
                              >
                                Batal
                              </button>
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              </div>
            ))}
          </div>
        ))}

      {/* SIMPAN */}
      {Object.keys(editData).length > 0 && (
        <div className="sticky bottom-0 bg-white p-4 border-t">
          <button
            onClick={simpanSemua}
            disabled={loading}
            className="bg-green-600 hover:bg-green-700 text-white px-6 py-3 rounded font-bold w-full"
          >
            {loading ? "Menyimpan..." : "Simpan Semua Perubahan"}
          </button>
        </div>
      )}

      <div className="flex justify-center mt-6">
        <Link to={`/profile/${id}`}>
          <Back />
        </Link>
      </div>
    </div>
  );
};

export default KURKUMlist;
